import React from 'react';
import FormSteps from '../FormSteps';
import FormField from '../../../../FormField';

/**
 * NameStep Component
 *
 * First step in the onboarding process to collect user's name
 *
 * @param {Object} formik - Formik instance with form state and methods
 * @param {Function} goToNextStep - Function to navigate to the next step
 */
const NameStep = ({ formik, goToNextStep }) => {
  const handleNext = async () => {
    formik.setFieldTouched('firstName', true);
    formik.setFieldTouched('lastName', true);
    const errors = await formik.validateForm();
    if (!errors.firstName && !errors.lastName) {
      goToNextStep();
    }
  };

  return (
    <FormSteps
      header="What's your name?"
      description="Let us know what to call you."
      nextButton={handleNext}
    >
      <div className="field mb-4">
        <div className="field-body">
          <FormField
            additionalInputClasses="has-background-white"
            name="firstName"
            placeholder="First name"
            onChange={formik.handleChange}
            value={formik.values.firstName}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>

      <div className="field mb-6">
        <div className="field-body">
          <FormField
            additionalInputClasses="has-background-white"
            name="lastName"
            placeholder="Last name"
            onChange={formik.handleChange}
            value={formik.values.lastName}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
    </FormSteps>
  );
};

export default NameStep;
